export default __webpack_public_path__ + "media/images/icons/plus-6495b69f1886a54fbdc4f32d698892f9.svg";